<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>请假信息：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px" :disabled="isEdit">
        <el-row>
<!--          <el-col :span="11">
            <el-form-item label="部门：" required>
              <el-select v-model="employeeData.apply_dept" placeholder="部门" filterable clearable :disabled="isEdit">
                <el-option v-for="item in deptOption" :key="item.field_code" :label="item.field_name" :value="item.field_code"/>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="11">
            <el-form-item label="员工：" required>
              <el-select v-model="employeeData.employee_no" placeholder="员工" filterable clearable>
                <el-option v-for="item in employeeList" :key="item.employee_no" :label="item.employee_name" :value="item.employee_no"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="假别：" required>
              <el-select v-model="employeeData.leave_code" placeholder="假别" @change="getLeaveUnit" clearable>
                <el-option v-for="item in leaveTypeList" :key="item.field_code" :label="item.field_name" :value="item.field_code"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="假别单位：" required>
              <el-select v-model="employeeData.duration_unit" disabled>
                <el-option v-for="item in unitList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="开始日期：" required>
              <el-date-picker v-model="employeeData.start_date" type="date"  :disabled="isEdit"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="开始时间：" v-show="employeeData.duration_unit === 'hour'" required>
              <el-time-select
                  v-model="employeeData.start_time"
                  start="00:00"
                  step="00:30"
                  end="24:00"
                  placeholder="结束时间"
              />
            </el-form-item>
            <el-form-item label="开始时间：" v-show="employeeData.duration_unit === 'halfday'" required>
              <el-select v-model="employeeData.start_time_str">
                <el-option v-for="item in rangeList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="结束日期：" required>
              <el-date-picker v-model="employeeData.end_date" type="date"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="结束时间："  v-show="employeeData.duration_unit === 'hour'" required>
              <el-time-select
                  v-model="employeeData.end_time"
                  start="00:00"
                  step="00:30"
                  end="24:00"
                  placeholder="结束时间"
              />
            </el-form-item>
            <el-form-item label="结束时间：" v-show="employeeData.duration_unit === 'halfday'" required>
              <el-select v-model="employeeData.end_time_str">
                <el-option v-for="item in rangeList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="请假时长(小时)：" required>
              <el-input-number v-model="employeeData.duration_percent" :precision="1" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="请假事由：" required>
              <el-input type="textarea" v-model="employeeData.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <h4>附件：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px" :disabled="isEdit">
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件：">
              <kf-file-upload v-model="employeeData.file_id" :init-file="fileList"
                              @fileChange="fileChange"
                              :limit="10" :showTotalCnt="true" ></kf-file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件照片：">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" :loading="loading" @click="save"  :disabled="isEdit">保存</el-button>
        </el-col>
      </el-row>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "EmployeeLeave",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    unitList() {
      return this.$store.getters['core/getDictList']('leave_unit');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      employee_no: '',
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:''
      },
      isEdit:false,
      isShow:false,
      photoType:'',
      dialogVisible: false,
      departmentList: [],
      leaveTypeList: [],
      employeeList:[],
      deptOption:[],
      rangeList:[],
      loading: false,
      fileList:[],
      attach_photo_id_obj:[]
    }
  },
  methods: {
    async loadEmployeeLeaveRecord() {
      let params = {id: this.parentData.id}
      this.$http('attendanceLeaveService.getLeaveById', params).then(data => {
        if (data) {
          this.isEdit = true;
          this.attach_photo_id_obj = data.attach_photo_id_obj;
          this.fileList = data.file_list;
          this.employeeData = data;
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //获取员工
    async getEmployee(){
      this.employeeList =await this.$http('employeeInfoService.getAllEmployeeNoList');
    },
    //获取假别
    async getLeaveType(){
      let params = {group_id: "vacation-1563793073898",template_id: "3WK7SwSQtwLdVLC9BLwaFbkRemcMfziYWBFdgJbA"}
      this.leaveTypeList = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取部门
    async getDeptOption() {
      let params = {group_id: "Selector-1653543744381",template_id: "3WK7SwSQtwLdVLC9BLwaFbkRemcMfziYWBFdgJbA"}
      this.deptOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    getLeaveUnit(){
      let params = {leave_code: this.employeeData.leave_code}
      this.$http('attendanceLeaveService.leaveCodeChange', params).then(data => {
        if (data) {
          this.employeeData.duration_unit = data.duration_unit;
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    getLeaveDuration(){
      let params = {
        "employee_no": this.employeeData.employee_no,
        "duration_unit": this.employeeData.duration_unit,
        "start_date": this.employeeData.start_date,
        "end_date": this.employeeData.end_date,
        "start_time": this.employeeData.start_time,
        "end_time": this.employeeData.end_time
      }
      this.$http('attendanceLeaveService.getLeaveDuration', params).then(data => {
        if (data) {
          this.employeeData.duration_percent = data.duration_percent;
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    async openCameraMain(){
      this.dialogVisible = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisible = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.employeeData.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisible = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    save() {
      if (!this.employeeData) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.employee_no) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.leave_code) {
        this.$message.error("请选择假别");
        return;
      }
      if (!this.employeeData.start_date) {
        this.$message.error("请选择开始日期");
        return;
      }
      if (!this.employeeData.end_date) {
        this.$message.error("请选择结束日期");
        return;
      }
      if(this.employeeData.duration_unit === 'hour'){
        if (!this.employeeData.start_time) {
          this.$message.error("请选择开始时间");
          return;
        }
        if (!this.employeeData.end_time) {
          this.$message.error("请选择结束时间");
          return;
        }
      }
      if(!this.employeeData.duration_percent){
        this.$message.error("请填写请假时长");
        return;
      }
      if (this.employeeData.remark == null || this.employeeData.remark === '') {
        this.$message.error("请填写请假事由！");
        return false;
      }
      this.loading = true;
      this.$http('attendanceLeaveService.insertLeave', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.employeeData.file_id = ids;
    },
  },
  created() {
    this.rangeList = [
      { name: '上午', value: '上午' },
      { name: '下午', value: '下午' }
    ];
    this.getEmployee();
    this.getLeaveType();
    this.loadEmployeeLeaveRecord();
    this.getDeptOption();
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 10px 0;
}

</style>